import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { name: "form" }
const _hoisted_4 = { class: "contain row" }
const _hoisted_5 = {
  key: 1,
  class: "page-container card col-md-8"
}
const _hoisted_6 = {
  key: 0,
  class: "row"
}
const _hoisted_7 = { class: "col-md-12 p-4" }
const _hoisted_8 = { class: "row mb-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3 required" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Parent Company:")
], -1)
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_12 = { class: "col-md-3" }
const _hoisted_13 = { class: "col-md-9" }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "d-flex align-items-center col-md-12" }
const _hoisted_16 = { class: "col-md-3" }
const _hoisted_17 = { class: "col-md-9" }
const _hoisted_18 = { class: "row mb-3" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3 required" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Purpose:")
], -1)
const _hoisted_20 = { class: "col-md-6" }
const _hoisted_21 = { class: "row mb-3" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3 required" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Month:")
], -1)
const _hoisted_23 = { class: "col-md-6" }
const _hoisted_24 = { class: "row mb-3" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Conso Group Name:")
], -1)
const _hoisted_26 = { class: "col-md-6" }
const _hoisted_27 = { class: "row mb-3" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Conso Group Description:")
], -1)
const _hoisted_29 = { class: "col-md-6" }
const _hoisted_30 = { class: "row" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Assign Company:")
], -1)
const _hoisted_32 = { class: "col-md-6" }
const _hoisted_33 = { class: "d-flex align-items-center col-md-12" }
const _hoisted_34 = { class: "col-md-3" }
const _hoisted_35 = { class: "col-md-9" }
const _hoisted_36 = { class: "col-md-3" }
const _hoisted_37 = { class: "row py-3 sticky-component" }
const _hoisted_38 = { class: "col-md-12" }
const _hoisted_39 = { class: "row mt-3 mb-2" }
const _hoisted_40 = { class: "conso-company-table-label mr-4" }
const _hoisted_41 = { class: "conso-company-table-label" }
const _hoisted_42 = { class: "row mb-3" }
const _hoisted_43 = { class: "col-md-12" }
const _hoisted_44 = {
  key: 0,
  class: "pi pi-exclamation-triangle align-text-bottom",
  style: {"color":"var(--bs-warning)"}
}
const _hoisted_45 = {
  key: 1,
  class: "pi pi-check align-text-bottom",
  style: {"color":"var(--bs-success)"}
}
const _hoisted_46 = { key: 1 }
const _hoisted_47 = {
  key: 0,
  class: "error-no-record mt-3"
}
const _hoisted_48 = /*#__PURE__*/_createElementVNode("h6", null, [
  /*#__PURE__*/_createElementVNode("span", null, "No Record Found")
], -1)
const _hoisted_49 = { class: "row mb-3" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, null, -1)
const _hoisted_51 = { class: "d-flex col-md-6" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("span", { class: "p-1" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheHeader = _resolveComponent("TheHeader")!
  const _component_TheSidebar = _resolveComponent("TheSidebar")!
  const _component_ThePageLoading = _resolveComponent("ThePageLoading")!
  const _component_ThePageHeader = _resolveComponent("ThePageHeader")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_Button = _resolveComponent("Button")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_TheLoading = _resolveComponent("TheLoading")!
  const _component_ThePageError = _resolveComponent("ThePageError")!
  const _component_TheFooter = _resolveComponent("TheFooter")!
  const _component_TheConfirmationDialog = _resolveComponent("TheConfirmationDialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TheHeader),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_TheSidebar),
            (_ctx.isPageLoading)
              ? (_openBlock(), _createBlock(_component_ThePageLoading, { key: 0 }))
              : _createCommentVNode("", true),
            (!_ctx.isPageLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_ThePageHeader, {
                    onDeleteEvent: _ctx.deleteConsoGroup,
                    renderDelete: (_ctx.identifier != null ? true : false),
                    isDeleting: _ctx.isDeleting
                  }, null, 8, ["onDeleteEvent", "renderDelete", "isDeleting"]),
                  (_ctx.pageError == '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            _hoisted_9,
                            _createElementVNode("div", _hoisted_10, [
                              _createVNode(_component_Dropdown, {
                                options: _ctx.filteredParentCompanies,
                                optionLabel: "code",
                                optionValue: "identifier",
                                filter: "",
                                filterFields: ['code', 'name'],
                                showClear: "",
                                placeholder: _ctx.isParentCompanyLoading ? ('Loading...') : '-- Please Select --',
                                loading: _ctx.isParentCompanyLoading,
                                modelValue: _ctx.consoGroup.parentCompany.identifier,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.consoGroup.parentCompany.identifier) = $event)),
                                disabled: _ctx.identifier != null,
                                onChange: _ctx.updateCompanyDropdown
                              }, {
                                value: _withCtx((slotProps) => [
                                  (slotProps.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                        _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.filterCompanyCodeByValue(slotProps.value)), 1),
                                        _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.filterCompanyNameByValue(slotProps.value)), 1)
                                      ]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(slotProps.placeholder), 1))
                                ]),
                                option: _withCtx((slotProps) => [
                                  _createElementVNode("div", _hoisted_15, [
                                    _createElementVNode("span", _hoisted_16, _toDisplayString(slotProps.option.code), 1),
                                    _createElementVNode("span", _hoisted_17, _toDisplayString(slotProps.option.name), 1)
                                  ])
                                ]),
                                _: 1
                              }, 8, ["options", "placeholder", "loading", "modelValue", "disabled", "onChange"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_18, [
                            _hoisted_19,
                            _createElementVNode("div", _hoisted_20, [
                              _createVNode(_component_Dropdown, {
                                options: _ctx.purposes,
                                optionLabel: "name",
                                optionValue: "identifier",
                                filter: "",
                                filterFields: ['name'],
                                showClear: "",
                                placeholder: _ctx.isPurposeLoading ? ('Loading...') : '-- Please Select --',
                                loading: _ctx.isPurposeLoading,
                                modelValue: _ctx.consoGroup.purpose.identifier,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.consoGroup.purpose.identifier) = $event)),
                                disabled: _ctx.identifier != null
                              }, null, 8, ["options", "placeholder", "loading", "modelValue", "disabled"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_21, [
                            _hoisted_22,
                            _createElementVNode("div", _hoisted_23, [
                              _createVNode(_component_Calendar, {
                                modelValue: _ctx.date,
                                "onUpdate:modelValue": [
                                  _cache[2] || (_cache[2] = ($event: any) => ((_ctx.date) = $event)),
                                  _ctx.updateConsoGroupDate
                                ],
                                view: "month",
                                manualInput: true,
                                dateFormat: "M yy",
                                placeholder: "Conso Group Month",
                                showIcon: "",
                                disabled: _ctx.identifier != null
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_24, [
                            _hoisted_25,
                            _createElementVNode("div", _hoisted_26, [
                              _createVNode(_component_InputText, {
                                modelValue: _ctx.consoGroupName,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.consoGroupName) = $event)),
                                readonly: ""
                              }, null, 8, ["modelValue"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_27, [
                            _hoisted_28,
                            _createElementVNode("div", _hoisted_29, [
                              _createVNode(_component_Textarea, {
                                modelValue: _ctx.consoGroup.description,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.consoGroup.description) = $event)),
                                rows: "1",
                                maxlength: "1000"
                              }, null, 8, ["modelValue"])
                            ])
                          ]),
                          _createVNode(_component_Divider),
                          _createElementVNode("div", _hoisted_30, [
                            _hoisted_31,
                            _createElementVNode("div", _hoisted_32, [
                              _createVNode(_component_MultiSelect, {
                                virtualScrollerOptions: { itemSize: 44 },
                                options: _ctx.filteredChildCompanies,
                                optionLabel: "code",
                                display: "chip",
                                filter: "",
                                filterFields: ['code', 'name'],
                                showClear: "",
                                placeholder: _ctx.isChildCompanyLoading ? ('Loading...') : '-- Please Select --',
                                loading: _ctx.isChildCompanyLoading,
                                modelValue: _ctx.selectedChildCompanies,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedChildCompanies) = $event)),
                                disabled: _ctx.consoGroup.purpose.identifier == null
                              }, {
                                option: _withCtx((slotProps) => [
                                  _createElementVNode("div", _hoisted_33, [
                                    _createElementVNode("span", _hoisted_34, _toDisplayString(slotProps.option.code), 1),
                                    _createElementVNode("span", _hoisted_35, _toDisplayString(slotProps.option.name), 1)
                                  ])
                                ]),
                                _: 1
                              }, 8, ["options", "placeholder", "loading", "modelValue", "disabled"])
                            ]),
                            _createElementVNode("div", _hoisted_36, [
                              _createVNode(_component_Button, {
                                class: "p-button-sm",
                                label: "Add",
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.addChildCompany(false))),
                                disabled: _ctx.selectedChildCompanies == null || _ctx.selectedChildCompanies.length == 0 || _ctx.consoGroup.purpose.identifier == null || _ctx.consoGroup.consoGroupYear == null || _ctx.consoGroup.consoGroupMonth == null
                              }, null, 8, ["disabled"]),
                              _createVNode(_component_Button, {
                                class: "p-button-sm ms-2",
                                label: "Add All",
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.addChildCompany(true))),
                                disabled: _ctx.filteredChildCompanies.length == 0 || _ctx.consoGroup.purpose.identifier == null || _ctx.consoGroup.consoGroupYear == null || _ctx.consoGroup.consoGroupMonth == null
                              }, null, 8, ["disabled"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_37, [
                            _createElementVNode("div", _hoisted_38, [
                              _createVNode(_component_Button, {
                                class: "p-button-icon-only me-2",
                                disabled: _ctx.selectedChildSequence == null,
                                "aria-label": "Filter",
                                onClick: _ctx.moveUp
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_FontAwesomeIcon, {
                                    icon: ['fas', 'fa-arrow-up'],
                                    size: "sm",
                                    width: "18px"
                                  })
                                ]),
                                _: 1
                              }, 8, ["disabled", "onClick"]),
                              _createVNode(_component_Button, {
                                class: "p-button-icon-only me-2",
                                disabled: _ctx.selectedChildSequence == null,
                                "aria-label": "Filter",
                                onClick: _ctx.moveDown
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_FontAwesomeIcon, {
                                    icon: ['fas', 'fa-arrow-down'],
                                    size: "sm",
                                    width: "18px"
                                  })
                                ]),
                                _: 1
                              }, 8, ["disabled", "onClick"]),
                              _createVNode(_component_Button, {
                                class: "p-button-icon-only me-2",
                                disabled: _ctx.selectedChildSequence == null,
                                "aria-label": "Filter",
                                onClick: _ctx.moveTop
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_FontAwesomeIcon, {
                                    icon: ['fas', 'fa-arrows-up-to-line'],
                                    size: "sm",
                                    width: "18px"
                                  })
                                ]),
                                _: 1
                              }, 8, ["disabled", "onClick"]),
                              _createVNode(_component_Button, {
                                class: "p-button-icon-only me-2",
                                disabled: _ctx.selectedChildSequence == null,
                                "aria-label": "Filter",
                                onClick: _ctx.moveBottom
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_FontAwesomeIcon, {
                                    icon: ['fas', 'fa-arrows-down-to-line'],
                                    size: "sm",
                                    width: "18px"
                                  })
                                ]),
                                _: 1
                              }, 8, ["disabled", "onClick"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_39, [
                            _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.filterCompanyCodeByValue(_ctx.consoGroup.parentCompany.identifier)), 1),
                            _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.filterCompanyNameByValue(_ctx.consoGroup.parentCompany.identifier)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_42, [
                            _createElementVNode("div", _hoisted_43, [
                              _createVNode(_component_DataTable, {
                                class: "conso-company-table",
                                value: _ctx.consoGroup.consoGroupCompanies,
                                selection: _ctx.selectedChildSequence,
                                "onUpdate:selection": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectedChildSequence) = $event)),
                                metaKeySelection: false,
                                selectionMode: "single"
                              }, {
                                empty: _withCtx(() => [
                                  (_ctx.consoGroup.consoGroupCompanies.length <= 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                        _createVNode(_component_FontAwesomeIcon, {
                                          icon: ['fas', 'image'],
                                          size: "2x"
                                        }),
                                        _hoisted_48
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_Column, {
                                    style: {"width":"3%"},
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.isGroup && slotProps.data.consoGroupId == null)
                                        ? _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_44, null, 512)), [
                                            [
                                              _directive_tooltip,
                                              'Group is undefined',
                                              void 0,
                                              { left: true }
                                            ]
                                          ])
                                        : (slotProps.data.isGroup && slotProps.data.consoGroupId != null)
                                          ? (_openBlock(), _createElementBlock("i", _hoisted_45))
                                          : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    style: {"width":"3%"},
                                    header: "#"
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    style: {"width":"10%"},
                                    field: "company.code",
                                    header: "Code"
                                  }),
                                  _createVNode(_component_Column, {
                                    style: {"width":"62%"},
                                    header: "Name"
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.isGroup)
                                        ? (_openBlock(), _createBlock(_component_Button, {
                                            key: 0,
                                            class: "p-button-link p-0",
                                            label: slotProps.data.company.name,
                                            onClick: ($event: any) => (_ctx.navigateTo(slotProps.data))
                                          }, null, 8, ["label", "onClick"]))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(slotProps.data.company.name), 1))
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    style: {"width":"12%"},
                                    header: "has CWK"
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_Checkbox, {
                                        modelValue: slotProps.data.isGroup,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.isGroup) = $event),
                                        binary: true,
                                        onChange: ($event: any) => (_ctx.checkConsoGroupExist(slotProps.data))
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    style: {"width":"10%"},
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_Button, {
                                        icon: "pi pi-trash",
                                        severity: "danger",
                                        text: "",
                                        rounded: "",
                                        onClick: ($event: any) => (_ctx.removeChildCompany(slotProps.index)),
                                        title: "Delete"
                                      }, null, 8, ["onClick"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["value", "selection"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_49, [
                            _hoisted_50,
                            _createElementVNode("div", _hoisted_51, [
                              _createVNode(_component_Button, {
                                class: "p-button-sm",
                                disabled: _ctx.v$.consoGroup.$invalid || _ctx.isLoading,
                                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.identifier == null ? _ctx.save() : _ctx.update())),
                                label: "Save"
                              }, null, 8, ["disabled"]),
                              _hoisted_52,
                              _createVNode(_component_Button, {
                                class: "p-button-sm p-button-secondary",
                                onClick: _ctx.cancel,
                                label: "Cancel"
                              }, null, 8, ["onClick"]),
                              (_ctx.isLoading)
                                ? (_openBlock(), _createBlock(_component_TheLoading, { key: 0 }))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.pageError != '')
                    ? (_openBlock(), _createBlock(_component_ThePageError, {
                        key: 1,
                        onBackEvent: _ctx.cancel,
                        pageError: _ctx.pageError
                      }, null, 8, ["onBackEvent", "pageError"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_TheFooter)
          ])
        ])
      ])
    ]),
    _createVNode(_component_TheConfirmationDialog, {
      loading: _ctx.confirmationDialog.isLoading,
      visible: _ctx.confirmationDialog.isVisible,
      header: _ctx.confirmationDialog.header,
      message: _ctx.confirmationDialog.message,
      status: "",
      onConfirm: _ctx.onDialogConfirm,
      onCancel: _ctx.onDialogCancel
    }, null, 8, ["loading", "visible", "header", "message", "onConfirm", "onCancel"])
  ], 64))
}